import { useEffect, useState } from 'react'

export function useLocalState<T>(defaultValue: T, key?: string) {
  const [value, setValue] = useState<T>(defaultValue)

  useEffect(() => {
    if (!key) return
    const persistedValueString = window.localStorage.getItem(key)
    if (persistedValueString !== null) {
      setValue(JSON.parse(persistedValueString))
    }
    return () => {}
  }, [])

  useEffect(() => {
    if (!key) return
    window.localStorage.setItem(key, JSON.stringify(value))
    return () => {}
  }, [key, value])

  if (!key) return [value, setValue] as [T, (newValue: T) => void]
  return [value, setValue] as [T, (newValue: T) => void]
}
